/**
 * Three SVG sort icons.
 *
 * Geometric spec (0.36.159 update):
 *  - Triangle height H = 6
 *  - Apex angle = 90°  →  full base = 2 * H * tan(45°) = 2 * H = 12
 *  - Vertical gap = 2 (≈ 33% of H)
 *  - Stroke weight = 0.1 * H = 0.6
 *  - Stroke color: ALWAYS solid black
 *
 * ViewBox 16×16:
 *  - Top triangle:    apex (8, 1)   base (2, 7)  → (14, 7)
 *  - Bottom triangle: base (2, 9)   → (14, 9)    apex (8, 15)
 *
 * State visuals (0.36.166 — grey fill removed):
 *  - Neutral:    both triangles outlined (black stroke, no fill)
 *  - Ascending:  top filled BLACK, bottom outline-only (same thin stroke as neutral)
 *  - Descending: top outline-only, bottom filled BLACK
 *
 * Same thin black stroke (0.1 × H = 0.6) on every outlined triangle so
 * the active state's "empty" triangle reads exactly like a neutral one.
 * The GREY_FILL constant is retained but no longer used (kept for any
 * future variant; safe to remove later).
 */
import React from 'react';

const TOP_PATH = 'M 8 1 L 14 7 L 2 7 Z';
const BOT_PATH = 'M 2 9 L 14 9 L 8 15 Z';

const STROKE_BLACK = 'var(--pt-head-color, var(--color-text-800))'; // 0.48.67 - follows the header text color // 0.44.74 - Henaket black (#1a1a1a), as the header text
const STROKE_WIDTH = 0.6;
const GREY_FILL = '#999999';

export function SortNeutralIcon({ size = 16 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 16 16" aria-hidden="true">
      <path d={TOP_PATH} fill="none" stroke={STROKE_BLACK}
            strokeWidth={STROKE_WIDTH} strokeLinejoin="miter" />
      <path d={BOT_PATH} fill="none" stroke={STROKE_BLACK}
            strokeWidth={STROKE_WIDTH} strokeLinejoin="miter" />
    </svg>
  );
}

export function SortAscIcon({ size = 16 }) {
  // 0.36.166 - inactive triangle is outline-only (matches neutral state),
  // not grey-filled. Same thin stroke as the neutral icon.
  return (
    <svg width={size} height={size} viewBox="0 0 16 16" aria-hidden="true">
      <path d={TOP_PATH} fill={STROKE_BLACK} stroke={STROKE_BLACK}
            strokeWidth={STROKE_WIDTH} strokeLinejoin="miter" />
      <path d={BOT_PATH} fill="none" stroke={STROKE_BLACK}
            strokeWidth={STROKE_WIDTH} strokeLinejoin="miter" />
    </svg>
  );
}

export function SortDescIcon({ size = 16 }) {
  // 0.36.166 - same as Asc: inactive triangle outline-only.
  return (
    <svg width={size} height={size} viewBox="0 0 16 16" aria-hidden="true">
      <path d={TOP_PATH} fill="none" stroke={STROKE_BLACK}
            strokeWidth={STROKE_WIDTH} strokeLinejoin="miter" />
      <path d={BOT_PATH} fill={STROKE_BLACK} stroke={STROKE_BLACK}
            strokeWidth={STROKE_WIDTH} strokeLinejoin="miter" />
    </svg>
  );
}
